import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { LanguageTranslationNode } from 'src/app/actions/admin/components/translations/models/language-translation-node';

@Component({
    selector: 'object-node',
    templateUrl: './object-node.component.html',
    styleUrls: ['./object-node.component.scss'],
    standalone: false
})
export class ObjectNodeComponent implements OnInit, OnChanges {

  @Input() isCollapsed: boolean = true;

  @Input() isFormReadonly: boolean = false;

  @Input() model: LanguageTranslationNode;

  @Input() isFiltered: boolean = false;

  @Output() formChanged = new EventEmitter();

  children: LanguageTranslationNode[];

  ngOnInit(): void {

    if (this.isFiltered) {
      this.isCollapsed = false;
    }

    if(!this.isCollapsed){
      this.buildChildren();
    }
    
  }

  ngOnChanges(changes: SimpleChanges) {

   if (Object.keys(changes).length === 1 && changes.isFiltered) {
    if(this.isFiltered) {
      this.isCollapsed = false;
      this.buildChildren()
    } else if(this.model.displayName){
      this.isCollapsed = true;
    }
   }
  }

  toggleCollapseState(){
    this.isCollapsed = !this.isCollapsed;

    if(!this.isCollapsed && !this.children){
      this.buildChildren();
    }
  }

  private buildChildren(){
    const keys = Object.keys(this.model.value);

    this.children = keys.map(x => this.model.value[x] as LanguageTranslationNode);
  }

  formDirty() {
    this.formChanged.emit();
  }
}
